import styled from 'styled-components';
import DateRange from 'material-ui/svg-icons/action/date-range';
import AccessTime from 'material-ui/svg-icons/device/access-time';

export const DetailsName = styled.div`
  color: rgba(107, 124, 147, 0.54);
  font-size: 16px;
`;

export const PickerContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const DateIcon = styled(DateRange)`
  position: absolute;
  right: 0;
  top: 8px;
`;

export const InviteText = styled.div`
  font-size: 24px;
  line-height: 32px;
  color: #6B7C93;
`;

export const ALertHeaderText = styled.div`
  font-size: 20px;
  color: rgba(50, 50, 93, 0.7);
`;

export const AlertText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: #F01631;
`;

export const ConfirmText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: #29B87A;
`;

export const AddText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #6B7C93;
`;

export const TimeIcon = styled(AccessTime)`
  position: absolute;
  right: 0;
  top: 8px;
`;



// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/styles.js